<script setup lang="ts">
const { label, position = 'down', space, color, closeBtn = false, twoLine = false }
  = defineProps<{
    label: string // 내용
    position?: string // 꼬리 위아래
    space?: number // 꼬리 위치
    color?: string // 배경색
    closeBtn?: boolean // 닫기버튼 유무
    twoLine?: boolean // 라벨 두줄
  }>()

const tooltip = ref<HTMLElement | null>(null)
const up = ref<HTMLElement | null>(null)
const down = ref<HTMLElement | null>(null)

const emit = defineEmits<{ (e: 'close'): void }>()

function setTooltipStyle() {
  if (tooltip.value) {
    if (position === 'up' && up.value) {
      // 화살표의 너비 절반만큼 빼주기
      up.value.style.left = space ? `${space}px` : `${tooltip.value.clientWidth / 2 - 4}px`
    }
    else if (down.value) {
      // 화살표의 너비 절반만큼 빼주기
      down.value.style.left = space ? `${space}px` : `${tooltip.value.clientWidth / 2 - 4}px`
    }
  }
}

onMounted(() => {
  setTooltipStyle()
})

onUpdated(() => {
  setTooltipStyle()
})
</script>

<template>
  <div
    ref="tooltip"
    :class="`tooltip-custom ${color? 'white' : ''}`"
  >
    <slot />
    <span
      v-dompurify-html="label"
      class="text-12"
    />
    <i-normal-tooltip-close-onview-01
      v-if="color && closeBtn"
      class="w-4 h-4 ml-1"
      @click="emit('close')"
    />
    <i-normal-tooltip-close
      v-else-if="closeBtn"
      class="w-4 h-4 ml-1"
      @click="emit('close')"
    />
    <i
      v-if="position === 'up'"
      ref="up"
      :class="`tooltip-up ${color? 'white' : ''} ${twoLine? 'two' : ''}`"
    />
    <i
      v-if="position === 'down'"
      ref="down"
      :class="`tooltip-down ${color? 'white' : ''} ${twoLine? 'two' : ''}`"
    />
  </div>
</template>
